import EditStaticDisplay from './StaticData'

export default {
  EditStaticDisplay,
}
